<template>
    <div id="app">
		<div class="header" :class="{'fixed':scrollActive}">
			<div class="logo_img">
			   <div style="display:flex; align-items: center; float:left; height: 60px;">
					<div class="header-logo">
						<a href="/mb_home"><img id="header-img" src="../../assets/img/logo.png" ></a>
					</div>
				</div>
				<div style="display:flex; float:left; height: 60px;">
					<div class="header-important">
						<div class="company_name"><a href="/mb_home">通慧科技集团</a>
							<a href="tel:0791-86613192" v-if="scrollActive"  style="font-size: 14px;color: #fd5353;margin-left: 5px;">
								0791-86613192
							</a>
						</div>
						<!-- <div class="header-title company_name">www.xxxxx.com</div> -->
					</div>
				</div>
			</div>
			<div id="menu_index">
				<i :style="{'color':navColor}" style="font-size: 24px;line-height: 65px;" class="el-icon-s-fold" @click="dialog = true"></i>                 
			</div>
		</div>
		
		<div class="container">
			<keep-alive>
			    <router-view v-if="$route.meta.keepAlive">
			        <!-- 这里是会被缓存的视图组件 -->
			    </router-view>
			</keep-alive>
			
			<router-view v-if="!$route.meta.keepAlive">
			    <!-- 这里是不被缓存的视图组件 -->
			</router-view>
		</div>
		
		<div class="footer">
			Copyright @ 2012-2022 江西通慧科技集团股份有限公司<br/>
			<a style="color: #666;" href="http://beian.miit.gov.cn" target="view_window">赣ICP备17002352号-1</a>
		</div>
        <div id="back_to_top" ref="btn" @click="backTop" :style="{display: topShow,}">
            <p style="font-size: 0.625em; font-weight: bold; text-align: center;">TOP</p>
            <img src="../../assets/img/launch.png" style="width: 35px" />
        </div>
		<el-drawer
		  title="目录"
		  :visible.sync="dialog"
		  :wrapperClosable="true"
		  direction="ltr"
		  custom-class="demo-drawer"
		  ref="drawer"
		  size="80%"
		  >
		  <div class="demo-drawer__content">
			<el-menu
			  :default-active="activeIndex"
			  class="el-menu-demo" 
			  menu-trigger="click" 
			  text-color="#333" 
			  style="border:0;" 
			  :unique-opened="true"
			  @select="handleSelectMobile"
			  :router="router"
			>
			  <el-menu-item index="/mb_home">首页</el-menu-item>
			  <el-menu-item index="/mb_company">公司简介</el-menu-item>
			  <el-submenu index="2">
				  <template slot="title">解决方案</template>
				  <el-submenu index="2-1">
					<template slot="title">结构物健康监测</template>
					<el-menu-item :route="{name:'mb_product',params: { id:'d908d3c2-3ea5-4b57-8a68-f108a5c12472',name:'桥梁'}}" index="2-1-1">桥梁</el-menu-item>
					<el-menu-item :route="{name:'mb_product',params: { id:'861460c1-28bf-4215-a52e-93ccfc282fc3',name:'隧道'}}" index="2-1-2">隧道</el-menu-item>
					<el-menu-item :route="{name:'mb_product',params: { id:'f8bc825b-7775-4bd1-9aac-3125355e26c2',name:'边坡'}}" index="2-1-3">边坡</el-menu-item>
					<el-menu-item :route="{name:'mb_product',params: { id:'ddc9fb8c-cd8c-4aa9-8f0b-eeee9c7bd2fa',name:'水利大坝'}}" index="2-1-4">水利大坝</el-menu-item>
					<el-menu-item :route="{name:'mb_product',params: { id:'40353b92-f97e-4fcb-8fbf-45c74b879731',name:'基坑'}}" index="2-1-5">基坑</el-menu-item>
					<el-menu-item :route="{name:'mb_product',params: { id:'d7246e15-44d1-4202-8255-e792d2f34aa3',name:'港口码头'}}" index="2-1-6">港口码头</el-menu-item>
					<el-menu-item :route="{name:'mb_product',params: { id:'4cd03ef4-00fa-4925-816f-928892c5b820',name:'健康监测'}}" index="2-1-7">健康监测</el-menu-item>
				  </el-submenu>
				  <el-submenu index="3-1">
					<template slot="title">智慧工地SAAS平台</template>
					<el-menu-item :route="{name:'mb_saas',params: { id:'c26fab28-881a-4e2a-835b-ab2c5fc01471',name:'项目管理'}}" index="3-1-1">项目管理</el-menu-item>
					<el-menu-item :route="{name:'mb_saas',params: { id:'e17987c9-8678-4858-8fd1-88ac5d3aaf83',name:'智慧工地'}}" index="3-1-2">智慧工地</el-menu-item>
					<el-menu-item :route="{name:'mb_saas',params: { id:'4fbcce7e-4fe1-4b19-8158-46567a9effe3',name:'AI智能分析'}}" index="3-1-3">AI智能分析</el-menu-item>
					<el-menu-item :route="{name:'mb_saas',params: { id:'0947db54-f664-4f45-8dcd-9a57b5675197',name:'特种设备'}}" index="3-1-4">特种设备</el-menu-item>
					<el-menu-item :route="{name:'mb_saas',params: { id:'e3dabe78-a784-4545-935a-92a1404cef4a',name:'智慧隧道'}}" index="3-1-5">智慧隧道</el-menu-item>
					<el-menu-item :route="{name:'mb_saas',params: { id:'be5feaf4-83b7-4246-a316-b6d04546c070',name:'VR运用'}}" index="3-1-6">VR运用</el-menu-item>
					<el-menu-item :route="{name:'mb_saas',params: { id:'e4ed4b04-7db0-447e-8b74-cd0ca59a695f',name:'监理云'}}" index="3-1-7">监理云</el-menu-item>
				  </el-submenu>
				  <el-submenu index="4-1">
					<template slot="title">智慧交通</template>
					<el-menu-item :route="{name:'mb_traffic',params: { id:'58e39bb2-8d1c-4e2c-8477-89986f74cf50',name:'智慧治超'}}" index="4-1-1">智慧治超</el-menu-item>
					<el-menu-item :route="{name:'mb_traffic',params: { id:'63779d4a-3588-4955-8855-d692fb65ef96',name:'科技示范路'}}" index="4-1-2">科技示范路</el-menu-item>
				  </el-submenu>
			  </el-submenu>
			  <el-submenu index="3">
				  <template slot="title">经典案例</template>
				  <el-menu-item index="/mb_case">结构物健康监测</el-menu-item>
				  <el-menu-item index="/mb_case02">智慧工地</el-menu-item>
				  <el-menu-item index="/mb_case01">智慧交通</el-menu-item>
				  <el-menu-item :route="{name:'mb_newsdetails',params: { id:'71f9c4ac-2854-497a-81ee-5136ea872e86'}}" index="3-2">业绩一览表</el-menu-item>
			  </el-submenu>
			  <el-menu-item index="/mb_news">新闻资讯</el-menu-item>
			  <el-menu-item index="/mb_contactus">联系我们</el-menu-item>
			</el-menu>
		  </div>
		</el-drawer>
    </div>
</template>

<script>
// import bus from '../bus.js'
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '/mb_home',
				router: true,
                scroll: '',
                currentMenu:'首页',
				scrollActive: false,
				navColor: "#fff",
				dialog: false,
				topShow: 'none'
            };
        },
		watch:{
			$route(to,from){
				document.body.scrollTop = document.documentElement.scrollTop = 0
				if(to.path.indexOf("mb") == -1){
					this.$router.push({path:'/mb_home'})
				}
			},
		},
        methods: {
            handleSelectMobile(key) {
				this.dialog = false
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
				if( this.scroll > 130){  //判断滚动后高度超过200px,就显示
					this.topShow = 'block'
					this.scrollActive = true
					this.navColor = "#333"
				}else{
					this.topShow = 'none'
					this.scrollActive = false
					this.navColor = "#fff"
				}
            },
            backTop(){ //当点击标签的时候,滚到顶部
                let timer = null,
                    _that = this;
                cancelAnimationFrame(timer);
                timer = requestAnimationFrame(function fn() {
                    if (_that.scroll > 0) {
                        _that.scroll -= 50;
                        document.body.scrollTop = document.documentElement.scrollTop = _that.scroll;
                        timer = requestAnimationFrame(fn);
                    } else {
                        cancelAnimationFrame(timer);
                    }
                });
            },
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll)
			// bus.$on("setData",message=>{
			//     if(message){
			//         this.activeIndex = message
			// 		// console.log(this.activeIndex)
			//     }
			// })
        }
    }
</script>

<style scoped lang="scss">
	.demo-drawer__content{
		height: calc(100vh - 100px);
		overflow-y: scroll;
	}
    .header-title{
        font-size: 12px;
    }
	#menu_index .el-menu{
		background: none;
	}
	.header.fixed{
		background: #fff;
		border-bottom: 1px solid #DDDDDD;
		.company_name{
			a{
				color: #000;
			}
	}
	}
    #header-img{
        width: 30px;
		height: 32.5px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 30px;
        width: 32.5px;
        align-self: center;
    }
    .header-important{
        float: left;
        align-self: center;
		color: #FFFFFF;
    }
	.header.fixed .header-important{
		color: #333;
	}
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
	#menu_index .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, 
	#menu_index .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, 
	#menu_index .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
		background: none;
	}
	.container{
		overflow: hidden;
	}
	.company_name{
		font-weight: normal;
		font-size: 16px;
		a{
			color: #fff;
		}
	}
	.header{
		display: flex;
		justify-content: space-between;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 9;
		box-sizing: border-box;
		width: 100%;
		height: 60px;
		padding: 0px 10px;
	}
	.logo_img{
		float:left;
		width: auto;
		cursor: pointer;
	}
	#back_to_top{
		position: fixed;
		bottom: 50px;
		right: 5px;
		cursor: pointer;
	}
	#menu_index{
		float: right;
		width: auto;
		height: 100%
	}
	.footer{
		height: 50px;
		font-size: 12px;
		line-height: 1.5;
		text-align: center;
		color: #999999;
		background-color: #f7f8f8;
		padding-top: 10px;
	}
</style>